module.exports = __webpack_public_path__ + "9821630ecc94c9565024993e5790e822.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-footer.png
// module id = 76
// module chunks = 0